import { trackSeoSearchProductListBrandLinkRefsClick } from "@faire/web-api/events/seo/click/searchProductListBrandLinkRefs";
import { trackEvent } from "@faire/web/common/trackEvent";
import kebabCase from "lodash/kebabCase";
import React from "react";

import { useSearchPageProductSearchString } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";

import { ProductTileContext } from "./common";
import { useGetProductTileClickImpressions } from "./productTileActions/useGetProductTileClickImpressions";
import { ProductClickForSearchPageParameters } from "./productTileActions/useOnProductClickForSearchPage";

export const useOnBrandClick = (
  params: ProductClickForSearchPageParameters
) => {
  const { recordBrandNameClickEvent } =
    useGetProductTileClickImpressions(params);
  const queryString = useSearchPageProductSearchString();
  const { brand } = React.useContext(ProductTileContext);

  return {
    onBrandClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
      recordBrandNameClickEvent();

      const productToken = params.token;
      if (!queryString || !productToken || !brand) {
        return;
      }
      trackEvent(
        `/search-click/${kebabCase(
          queryString
        )}/product/${productToken}/brand/${brand.token}`
      );

      trackSeoSearchProductListBrandLinkRefsClick(
        brand.token ?? "",
        queryString
      );

      event.stopPropagation();
    },
  };
};
